import { Button, Modal } from "antd";
import { useContext, useEffect, useMemo } from "react";
import SettingContext from "../../core/context/SettingContext";
import {
  Magnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION,
} from "react-image-magnifiers";
import NoimageLogo from '../../assets/images/no-image.png';
import { getFileExtension, getFileType } from "utils/fileUtils";

const ProductDetailModal = () => {
  const {mProductShow, setMProductShow, mProductShowDetail, mProductIndex, setMProductIndex} = useContext(SettingContext);
  // DetailCard filters images only; the modal must use the same list or the index will point to a non-image URL.
    const imageUrls = useMemo(() => {
      const urls = mProductShowDetail?.imageURLs || [];
      return urls.filter((u) => getFileType(getFileExtension(u)) === "IMAGE");
    }, [mProductShowDetail]);

    const safeIndex = useMemo(() => {
      if (!Array.isArray(imageUrls) || imageUrls.length === 0) return 0;
      if (typeof mProductIndex !== 'number') return 0;
      return Math.min(Math.max(mProductIndex, 0), imageUrls.length - 1);
    }, [imageUrls, mProductIndex]);

    useEffect(() => {
      if (mProductShow && safeIndex !== mProductIndex) {
        setMProductIndex(safeIndex);
      }
    }, [mProductShow, mProductIndex, safeIndex, setMProductIndex]);

    const currentSrc = imageUrls?.[safeIndex] || NoimageLogo;

  return (
    <Modal
      className="w-full productDetailInfoModal"
      width="100%"
      height="100vh"
      centered
      open={mProductShow}
      footer={false}
      closable={false}
    >
      <div className="flex flex-col justify-between h-full">
        <div>
          <Button onClick={() => setMProductShow(false)}>Back</Button>
        </div>
        <div className="overflow-auto">
          <Magnifier
            className="productMagnifier"
			imageSrc={currentSrc}
			imageAlt={mProductShowDetail?.name || "Image"}
			largeImageSrc={currentSrc}
            mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK}
            touchActivation={TOUCH_ACTIVATION.LONG_TOUCH}
          />
        </div>
        {imageUrls?.length > 1 && (
          <div className="p-20 flex gap-10 overflow-x-auto flex-nowrap">
            {imageUrls.map((e, i) => (
            <div
              className={"m-5 bg-white border-2 hover:cursor-pointer " + (mProductIndex === i && 'border-supernova')}
              key={i}
            >
              <img
                src={e}
                height="85px"
                width="85px"
                onClick={() => setMProductIndex(i)}
              />
            </div>
          ))}
        </div>
	  )}
      </div>
    </Modal>
  )
}
export default ProductDetailModal;